import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
interface Slide5Props {
  onNext: () => void;
  onBack: () => void;
}
export function Slide5({
  onNext,
  onBack
}: Slide5Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." progress={{
    current: 2,
    total: 3
  }} onBack={onBack} data-id="element-187">
      <div className="w-full max-w-7xl mx-auto grid grid-cols-5 gap-8 items-center" data-id="element-188">
        <div className="col-span-3 space-y-6" data-id="element-189">
          <h1 className="text-3xl font-bold text-white mb-2 uppercase" data-id="element-190">
            WHY DUAL TARGETING?
          </h1>
          <div className="space-y-4" data-id="element-191">
            <p className="text-xl text-white font-bold uppercase leading-snug" data-id="element-192">
              ANG-2 AND VEGF-A ACT SYNERGISTICALLY TO INCREASE:¹
            </p>
            <ul className="space-y-2 text-lg text-white font-bold pl-4" data-id="element-193">
              <li className="flex items-center" data-id="element-194">
                <span className="w-2 h-0.5 bg-white mr-3" data-id="element-195"></span>
                <span data-id="element-196">VASCULAR PERMEABILITY</span>
              </li>
              <li className="flex items-center" data-id="element-197">
                <span className="w-2 h-0.5 bg-white mr-3" data-id="element-198"></span>
                <span data-id="element-199">INFLAMMATION</span>
              </li>
              <li className="flex items-center" data-id="element-200">
                <span className="w-2 h-0.5 bg-white mr-3" data-id="element-201"></span>
                <span data-id="element-202">PATHOLOGICAL ANGIOGENESIS</span>
              </li>
            </ul>
            <p className="text-lg text-white/90 italic leading-snug pt-2" data-id="element-203">
              Targeting both pathways addresses mechanisms contributing to
              vascular instability.
            </p>
          </div>
          <div className="pt-4" data-id="element-204">
            <Button variant="primary" onClick={onNext} data-id="element-205">
              WHY IT MATTERS
            </Button>
          </div>
        </div>
        <div className="col-span-2 flex items-center justify-center" data-id="element-206">
          <div className="relative p-1 rounded-3xl bg-gradient-to-br from-[#1B3A5C] via-[#0E8585] to-[#3DA06D]" data-id="element-207">
            <div className="bg-white rounded-3xl p-3" data-id="element-208">
              <img src="https://cdn.magicpatterns.com/uploads/6jLaiLqH5Z2ZziNHjuoZBF/Screenshot_2026-02-16_at_13.43.57.png" alt="Vascular instability showing pericyte loss, endothelial destabilization, and pathological angiogenesis" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-209" />
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}